import React, { useState } from "react";

const TreeNode = ({ node, depth = 0, onSelectFile }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    if (node.droppable) setIsOpen(!isOpen);
  };

  const handleClick = () => {
    if (!node.droppable) {
      onSelectFile(node.fullPath);
    }
  };

  return (
    <div style={{ paddingLeft: depth * 20 }}>
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        {node.droppable && (
          <span onClick={handleToggle} style={{ marginRight: 5 }}>
            {isOpen ? "[-]" : "[+]"}
          </span>
        )}
        <span onClick={handleClick}>{node.text}</span>
      </div>
      {isOpen &&
        node.children.map((child) => (
          <TreeNode
            key={child.id}
            node={child}
            depth={depth + 1}
            onSelectFile={onSelectFile}
          />
        ))}
    </div>
  );
};

export default TreeNode;
